import { _ } from "i18n";
import type { GPEventResponse, GPHalfResponse } from "../../../../../../../frontend/portal/src/libs/apiClient";
import { TimelineItem } from "./TimelineItem";
import { handlePlayEvent } from "../../../functions";
import { useVideoPlayer } from "../../../Contexts/contexts";
import React, { useContext } from "react";
interface TimelineHalfProps {
    events: GPEventResponse[];
    half: GPHalfResponse;
    homeTeamId: number;
    handleGetTimestamp: (event: GPEventResponse) => string | number | undefined;
    containerRef: React.RefObject<HTMLDivElement>;
}

export function TimelineHalf({ events, half, homeTeamId, handleGetTimestamp, containerRef }: TimelineHalfProps) {
    const { playerRef } = useVideoPlayer();

    const numberToString = (num: number) => {
        switch (num) {
            case 1:
                return _("timeline.first_half_start");
            case 2:
                return _("timeline.second_half_start");
            case 3:
                return _("timeline.extra_half_one_start");
            case 4:
                return _("timeline.extra_half_two_start");
            case 5:
                return _("timeline.extra_half_three_start");
        }
    }

    return (
        <div className="timelineHalf-container">
            <div className="matchHalfTimestamp" onClick={() => {
                handlePlayEvent(playerRef, half.videoTimeStart)
            }}>
                <span className="icon-new icon-whistle icon-16" />
                {numberToString(half.id)}
            </div>
            <div className="timelineItems-container">
                {events.length > 0 ?
                    <>
                        {events.map((event) => <TimelineItem
                            key={event.id}
                            event={event}
                            homeTeamId={homeTeamId}
                            handleGetTimestamp={handleGetTimestamp}
                            containerRef={containerRef}
                        />)}
                    </>
                    :
                    <>{_("message.gamePage.noRelevantEvents")}</>
                }
            </div>
        </div>
    );
}
